import { useSelector } from 'react-redux'
import { Loading as LoadingCommon } from '../../../../common/loading'
import classes from './index.module.scss'
import { KEY_LOADING, selectLoading } from './store/slice'

const Loading = () => {
  const loading = useSelector(selectLoading(KEY_LOADING.DETAIL_TEMPLATE))

  return (
    <>
      {loading && (
        <div className={classes.loadingContainerBlur}>
          <div className="wh100 positionRelative">
            <LoadingCommon />
          </div>
        </div>
      )}
    </>
  )
}

export default Loading
